'use client'

export {
  DIALOG_VARIANTS,
  Dialog,
  type DialogProps,
  type DialogVariant,
  useDialogVariant
} from './Dialog'
export { DialogActions } from './DialogActions'
export { DialogBody } from './DialogBody'
export { DialogDescription } from './DialogDescription'
export { DialogTitle } from './DialogTitle'
